import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { RouteKeys } from '~/router/routes.domain';

export const ExportRoute: RouteRecordRaw = {
	name: RouteKeys.EXPORT,
	path: 'export',
	components: {
		default: () => import('../export/ui/pages/ExportPage.vue')
	},
	meta: {
		label: 'export.navigation',
		icon: () => $i('export'),
		requiresAuth: true,
		isSettingsNavEntry: true,
		isSubEntry: false,
		order: 1
	}
};
